module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('section', {
    staticClass: "radio-material"
  }, [_c('div', {
    staticClass: "module"
  }, [_c('div', {
    staticClass: "p-b-15 radio-content"
  }, [_c('z-radio-bar', {
    attrs: {
      "list-obj": _vm.radioBarParams.list,
      "active": _vm.radioBarParams.active
    },
    on: {
      "handleClickRadioBar": _vm.handleClickRadioBar
    }
  })], 1), _vm._v(" "), (_vm.radioBarParams.active == 'text') ? _c('div', {
    staticClass: "reply-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textContent),
      expression: "textContent"
    }],
    staticClass: "edit",
    attrs: {
      "placeholder": "请输入回复内容..."
    },
    domProps: {
      "value": (_vm.textContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textContent = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.radioBarParams.active == 'news') ? _c('div', {
    staticClass: "reply-news"
  }, [(_vm.radioBarParams.list[1].content) ? _c('div', {
    staticClass: "reply"
  }, [_c('ul', _vm._l((_vm.radioBarParams.list[1].content.newsItem || []), function(item) {
    return _c('li', [_c('div', {
      staticClass: "item fx"
    }, [_c('h6', {
      staticClass: "fx-fill"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "pic fx-shrink"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("showWxImages")(item.picurl)
      }
    })])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.description),
        expression: "item.description"
      }]
    }, [_vm._v(_vm._s(item.description))])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "del-btn"
  }, [_c('a', {
    on: {
      "click": _vm.handleDelContent
    }
  }, [_vm._v("删除")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.radioBarParams.list[1].content),
      expression: "!radioBarParams.list[1].content"
    }],
    staticClass: "fx"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCustomNews),
      expression: "!isCustomNews"
    }],
    staticClass: "fx"
  }, [_c('div', {
    staticClass: "add-material",
    on: {
      "click": _vm.showLayers
    }
  }, [_c('p', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('h5', [_vm._v("从图文素材库选择")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.radioBarParams.list[1].content),
      expression: "!radioBarParams.list[1].content"
    }],
    staticClass: "add-material m-l-10",
    on: {
      "click": function($event) {
        return _vm.handleIsShowCustomNews(true)
      }
    }
  }, [_c('p', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('h5', [_vm._v("跳转外部链接图文")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCustomNews),
      expression: "isCustomNews"
    }],
    staticClass: "fx link-cont"
  }, [_c('div', {
    staticClass: "thumbnail-grp"
  }, [_c('ul', _vm._l((_vm.newsObj.newsItem || []), function(item) {
    return _c('li', [_c('div', {
      staticClass: "thumbnail"
    }, [_c('h6', [_vm._v(_vm._s(item.title || '标题...'))]), _vm._v(" "), _c('div', {
      staticClass: "pic-cont"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("showWxImages")(item.picurl)
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(item.description || '摘要...'))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "edit-cont p-l-10"
  }, [_c('p', [_c('a', {
    staticClass: "z-btn c-m b-r-3",
    on: {
      "click": _vm.handleShowImageLayer
    }
  }, [_vm._v(_vm._s(_vm.newsObj.newsItem[0].picurl ? "重新选择封面" : "选择封面素材"))]), _c('span', {
    staticClass: "c-g m-l-10"
  }, [_vm._v("封面建议尺寸：900 x 500")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newsObj.newsItem[0].title),
      expression: "newsObj.newsItem[0].title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入标题",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.newsObj.newsItem[0].title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newsObj.newsItem[0], "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newsObj.newsItem[0].description),
      expression: "newsObj.newsItem[0].description"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入摘要",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.newsObj.newsItem[0].description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newsObj.newsItem[0], "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newsObj.newsItem[0].url),
      expression: "newsObj.newsItem[0].url"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入点击跳转的URL地址,如：http://xxx.com",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.newsObj.newsItem[0].url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newsObj.newsItem[0], "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "m-t-15"
  }, [_c('a', {
    staticClass: "z-btn c-m b-r-3",
    on: {
      "click": _vm.handleSaveCustomNews
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-default b-r-3 m-l-15",
    on: {
      "click": function($event) {
        return _vm.handleIsShowCustomNews(false)
      }
    }
  }, [_vm._v("返回")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.radioBarParams.active == 'image') ? _c('div', {
    staticClass: "reply-image"
  }, [(_vm.radioBarParams.list[2].content) ? _c('div', {
    staticClass: "reply"
  }, [_c('p', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm._f("showWxImages")(_vm.radioBarParams.list[2].content.content.url)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "del-btn"
  }, [_c('a', {
    on: {
      "click": _vm.handleDelContent
    }
  }, [_vm._v("删除")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.radioBarParams.list[2].content),
      expression: "!radioBarParams.list[2].content"
    }],
    staticClass: "add-material",
    on: {
      "click": _vm.showLayers
    }
  }, [_c('p', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('h5', [_vm._v("从图片素材库选择")])])]) : _vm._e(), _vm._v(" "), (_vm.radioBarParams.active == 'voice') ? _c('div', {
    staticClass: " reply-voice"
  }, [(_vm.radioBarParams.list[3].content) ? _c('div', {
    staticClass: "reply"
  }, [_c('div', {
    staticClass: "voice"
  }, [_c('h6', [_vm._v(_vm._s(_vm.radioBarParams.list[3].content.content.name))]), _vm._v(" "), _c('p', {
    staticClass: "icon-voice"
  })]), _vm._v(" "), _c('p', {
    staticClass: "del-btn"
  }, [_c('a', {
    on: {
      "click": _vm.handleDelContent
    }
  }, [_vm._v("删除")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.radioBarParams.list[3].content),
      expression: "!radioBarParams.list[3].content"
    }],
    staticClass: "add-material",
    on: {
      "click": _vm.showLayers
    }
  }, [_c('p', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('h5', [_vm._v("从语音素材库选择")])])]) : _vm._e(), _vm._v(" "), (_vm.radioBarParams.active == 'video') ? _c('div', {
    staticClass: "reply-video"
  }, [(_vm.radioBarParams.list[4].content) ? _c('div', {
    staticClass: "reply"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('h6', [_vm._v(_vm._s(_vm.radioBarParams.list[4].content.content.title))]), _vm._v(" "), _c('p', {
    staticClass: "icon-video"
  })]), _vm._v(" "), _c('p', {
    staticClass: "del-btn"
  }, [_c('a', {
    on: {
      "click": _vm.handleDelContent
    }
  }, [_vm._v("删除")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.radioBarParams.list[4].content),
      expression: "!radioBarParams.list[4].content"
    }],
    staticClass: "add-material",
    on: {
      "click": _vm.showLayers
    }
  }, [_c('p', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('h5', [_vm._v("从视频素材库选择")])])]) : _vm._e()])]), _vm._v(" "), _c('z-layers-material', {
    attrs: {
      "is-show": _vm.isLayerMaterial,
      "title": '素材管理'
    },
    on: {
      "handleOk": _vm.getMaterial,
      "handleCancel": _vm.handleCancel
    }
  }, [_c('z-material', {
    attrs: {
      "is-get-material": _vm.isLayerMaterial,
      "is-tab-bar": _vm.isMaterialTabBar,
      "type": _vm.radioBarParams.active
    },
    on: {
      "handleSelectMaterial": _vm.handleSelectMaterial
    }
  })], 1), _vm._v(" "), _c('z-layers-material', {
    attrs: {
      "is-show": _vm.isLayerImage,
      "title": '素材管理'
    },
    on: {
      "handleOk": _vm.getImage,
      "handleCancel": _vm.handleCancelImage
    }
  }, [_c('z-material', {
    attrs: {
      "is-get-material": _vm.isLayerImage,
      "is-tab-bar": _vm.isMaterialTabBar,
      "type": 'image'
    },
    on: {
      "handleSelectMaterial": _vm.handleSelectImage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6be9e55a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/RadioMaterial.vue
// module id = 862
// module chunks = 0